/* Tabs window js function Open/Close start */
function Tabs() {
  var container = document.querySelector(".tab-component");
  var triggers = container.querySelectorAll('[role="tab"]');
  var contents = container.querySelectorAll('[role="tabpanel"]');

  function toggleTab() {
    var tabId = this.getAttribute("aria-controls");

    contents.forEach(function (content) {
      var isVisible = content.id === tabId;
      content.setAttribute("aria-hidden", !isVisible);
    });

    triggers.forEach(function (trigger) {
      var isSelected = trigger.getAttribute("aria-controls") === tabId;
      trigger.setAttribute("aria-selected", isSelected);
    });

    logSelectedTabText(this);

    // Update the URL with the tab's name
    var tabName = this.innerText.trim()
    window.location.hash = encodeURIComponent(tabName);
  }

  function logSelectedTabText(tabElement) {
    if (tabElement.getAttribute("aria-selected") === "true") {
      var getTabInnertext = tabElement.innerText.trim();
      var elements = document.querySelectorAll('.faq-all-in-one-tab-content');
      var inputValues = [];
      elements.forEach(function (element) {
        var inputElement = element.querySelector('input');
        if (inputElement) {
          inputValues.push(inputElement.value);
        }
      });
      var targetValue = inputValues.find(function (value) {
        return value === getTabInnertext;
      });
      $(".faq-all-in-one-tab-content").each(function () {
        var contentText = $(this).find('input').val();
        if (contentText === targetValue) {
          $(this).removeClass("hide");
        } else {
          $(this).addClass("hide");
        }
      });
    }
  }

  function initializeTabFromURL() {
    // Read the tab name from the URL hash
    var tabNameFromURL = decodeURIComponent(window.location.hash.slice(1)); // Remove the '#' symbol

    // Find the corresponding tab element and select it
    triggers.forEach(function (trigger) {
      if (trigger.innerText.trim() === tabNameFromURL) {
        trigger.click();
      }
    });
  }

  function bindEventListeners() {
    triggers.forEach(function (trigger) {
      trigger.addEventListener("click", toggleTab);
      trigger.addEventListener("keydown", function (event) {
        if (event.key === "Enter") {
          toggleTab.call(this);
        }
      });
    });

    // Call this function to initialize the tab from the URL when the page loads
    initializeTabFromURL();
  }

  bindEventListeners();
}

window.addEventListener("load", function () {
  var tabs = new Tabs();
  var firstTabButton = document.querySelector('[aria-selected="true"]');
  firstTabButton.click();
});

/* Tabs window js function Open/Close end */

/* Mobile scrolling functionality Start */
/**
  Horizontal scrolling menu.
  @param {Object} object - Container for all options.
  @param {string || DOM node} wrapperSelector - Container element selector.
  @param {string} selector - Scroller element selector.
  @param {string} contentSelector - Scroller content element selector.
  @param {string} buttonLeftSelector - Left button selector.
  @param {string} buttonRightSelector - Right button selector.
  @param {integer} scrollStep - Amount to scroll on button click.
*/

document.addEventListener("DOMContentLoaded", function () {
  var navScroller = function ({
    wrapperSelector: wrapperSelector = '.nav-scroller-wrapper',
    selector: selector = '.nav-scroller',
    contentSelector: contentSelector = '.nav-scroller-content',
    buttonLeftSelector: buttonLeftSelector = '.nav-scroller-btn--left',
    buttonRightSelector: buttonRightSelector = '.nav-scroller-btn--right',
    scrollStep: scrollStep = 100
  } = {}) {
    var scrolling = false;
    var scrollingDirection = '';
    var scrollOverflow = '';
    var timeout;
    var navScrollerWrapper;
    if (wrapperSelector.nodeType === 1) {
      navScrollerWrapper = wrapperSelector;
    }
    else {
      navScrollerWrapper = document.querySelector(wrapperSelector);
    }
    if (navScrollerWrapper === undefined || navScrollerWrapper === null) return;
    var navScroller = navScrollerWrapper.querySelector(selector);
    var navScrollerContent = navScrollerWrapper.querySelector(contentSelector);
    var navScrollerLeft = navScrollerWrapper.querySelector(buttonLeftSelector);
    var navScrollerRight = navScrollerWrapper.querySelector(buttonRightSelector);
    // Sets overflow
    var setOverflow = function () {
      scrollOverflow = getOverflow(navScrollerContent, navScroller);
      toggleButtons(scrollOverflow);
    }
    // Debounce setting the overflow with requestAnimationFrame
    var requestSetOverflow = function () {
      if (timeout) {
        window.cancelAnimationFrame(timeout);
      }
      timeout = window.requestAnimationFrame(() => {
        setOverflow();
      });
    }
    // Get overflow value on scroller
    var getOverflow = function (content, container) {
      var containerMetrics = container.getBoundingClientRect();
      var containerWidth = containerMetrics.width;
      var containerMetricsLeft = Math.floor(containerMetrics.left);
      var contentMetrics = content.getBoundingClientRect();
      var contentMetricsRight = Math.floor(contentMetrics.right);
      var contentMetricsLeft = Math.floor(contentMetrics.left);
      // Offset the values by the left value of the container
      var offset = containerMetricsLeft;
      containerMetricsLeft -= offset;
      contentMetricsRight -= offset + 1; // Due to an off by one bug in iOS
      contentMetricsLeft -= offset;
      if (containerMetricsLeft > contentMetricsLeft && containerWidth < contentMetricsRight) {
        return 'both';
      } else if (contentMetricsLeft < containerMetricsLeft) {
        return 'left';
      } else if (contentMetricsRight > containerWidth) {
        return 'right';
      } else {
        return 'none';
      }
    }
    // Move the scroller with a transform
    var moveScroller = function (direction) {
      if (scrolling === true) return;
      setOverflow();
      var scrollDistance = scrollStep;
      var scrollAvailable;
      if (scrollOverflow === direction || scrollOverflow === 'both') {
        if (direction === 'left') {
          scrollAvailable = navScroller.scrollLeft;
        }
        if (direction === 'right') {
          var navScrollerRightEdge = navScroller.getBoundingClientRect().right;
          var navScrollerContentRightEdge = navScrollerContent.getBoundingClientRect().right;

          scrollAvailable = Math.floor(navScrollerContentRightEdge - navScrollerRightEdge);
        }
        // If there is less that 1.5 steps available then scroll the full way
        if (scrollAvailable < (scrollStep * 1.5)) {
          scrollDistance = scrollAvailable;
        }
        if (direction === 'right') {
          scrollDistance *= -1;
        }
        navScrollerContent.classList.remove('no-transition');
        navScrollerContent.style.transform = 'translateX(' + scrollDistance + 'px)';
        scrollingDirection = direction;
        scrolling = true;
      }
    }
    // Set the scroller position and removes transform, called after moveScroller()
    var setScrollerPosition = function () {
      var style = window.getComputedStyle(navScrollerContent, null);
      var transform = style.getPropertyValue('transform');
      var transformValue = Math.abs(parseInt(transform.split(',')[4]) || 0);
      if (scrollingDirection === 'left') {
        transformValue *= -1;
      }
      navScrollerContent.classList.add('no-transition');
      navScrollerContent.style.transform = '';
      navScroller.scrollLeft = navScroller.scrollLeft + transformValue;
      navScrollerContent.classList.remove('no-transition');
      scrolling = false;
    }
    // Toggle buttons depending on overflow
    var toggleButtons = function (overflow) {
      navScrollerLeft.classList.remove('active');
      navScrollerRight.classList.remove('active');
      if (overflow === 'both' || overflow === 'left') {
        navScrollerLeft.classList.add('active');
      }
      if (overflow === 'both' || overflow === 'right') {
        navScrollerRight.classList.add('active');
      }
    }
    var init = function () {
      // Determine scroll overflow
      setOverflow();
      // Scroll listener
      navScroller.addEventListener('scroll', () => {
        requestSetOverflow();
      });
      // Resize listener
      window.addEventListener('resize', () => {
        requestSetOverflow();
      });
      // Button listeners
      navScrollerLeft.addEventListener('click', () => {
        moveScroller('left');
      });
      navScrollerRight.addEventListener('click', () => {
        moveScroller('right');
      });
      // Set scroller position
      navScrollerContent.addEventListener('transitionend', () => {
        setScrollerPosition();
      });
    };
    // Init is called by default
    init();
    // Reveal API
    return {
      init
    };
  };

  var navScrollerInstance = navScroller()
});
/* Mobile scrolling functionality End */

/* Accordian tab open
   Accordion Tab Content - FAQ Restructure with Accordion (Plus/Minus) and Keyboard Accessibility
   This function is designed for restructuring an FAQ section using an accordion-style layout with plus and minus icons,
   and ensuring keyboard accessibility. It is implemented in the tab-content-faq.liquid file.
*/
document.addEventListener('DOMContentLoaded', function () {
  var accordionItems = document.querySelectorAll('.accordion-item');
  accordionItems.forEach((item) => {
    var button = item.querySelector('.accordion-button');
    var content = item.querySelector('.accordion-content');
    var icon = item.querySelector('.accordion-icon');
    button.addEventListener('click', function () {
      var expanded = button.getAttribute('aria-expanded') === 'true';
      button.setAttribute('aria-expanded', !expanded);
      content.style.display = expanded ? 'none' : 'block';
      icon.textContent = expanded ? '+' : '-';
      content.setAttribute('aria-hidden', expanded);
    });
    button.addEventListener('keydown', function (e) {
      var keyCode = e.which || e.keyCode;
      switch (keyCode) {
        case 13: // Enter key
        case 32: // Spacebar
          e.preventDefault();
          button.click();
          break;
        case 38: // Up arrow
          e.preventDefault();
          if (item.previousElementSibling) {
            item.previousElementSibling.querySelector('.accordion-button').focus();
          }
          break;
        case 40: // Down arrow
          e.preventDefault();
          if (item.nextElementSibling) {
            item.nextElementSibling.querySelector('.accordion-button').focus();
          }
          break;
      }
    });
  });
});